import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-vive-directory-widget',
  templateUrl: './vive-directory-widget.component.html',
  styleUrls: ['./vive-directory-widget.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ViveDirectoryWidgetComponent {
  constructor(
    private router: Router,
    private ToastService: ToastService
  ) {}

  @Input() CompanyId!: number;

  navigateToVendorSearchPage() {
    this.router.navigate([
      'client',
      this.CompanyId,
      'vendors',
      'search',
      'vive'
    ]);
  }

  ngOnInit(): void {
    if (!this.CompanyId) {
      throw this.ToastService.addErrorToast('Error', 'Missing Client Id.', {
        returnError: true
      });
    }
  }
}
